export default {"src":"/_next/static/image/src/images/our-food/sweet-potato.ca4ce80fd20db2b61b183ed3a3c475a0.svg","height":29,"width":84};